import { Component, OnInit } from '@angular/core';
import { ReportService } from '../../../services/report.service';
import { ClientBalanceReportFilter } from '../../../models/reports/client.balance.report.filter';
import { ClientBalanceReport } from '../../../models/reports/client.balance.report';
import { DateHelper } from '../../../helpers/DateHelper';
import { ClientService } from '../../../services/client.service';
import { Client } from '../../../models/clients/client';
import { AlertService } from '../../../services/alert.service';
import { saveAs } from 'file-saver'
import { TripBalanceReport } from '../../../models/reports/trip.balance.report';

@Component({
	selector: 'app-client-collectible',
	templateUrl: './client-collectible.component.html',
	styleUrls: ['./client-collectible.component.css']
})
export class ClientCollectibleComponent implements OnInit {

	data: ClientBalanceReport[] = [];
	filter: ClientBalanceReportFilter;
	client: Client = new Client();
	isLoading = false;

	constructor(
		private _reportService: ReportService,
		private _clientService: ClientService,
		private _alertService: AlertService
	) { }

	ngOnInit() {
		this.filter = new ClientBalanceReportFilter();
		this.filter.isPaid = false;
	}

	fetch(exportReport:boolean = false){
		if(!this.filter.clientId || isNaN(this.filter.clientId)){
			this._alertService.showError('A Client must be selected.');
			return;
		}

		try{
			this.isLoading = true
			this._clientService.getClient(this.filter.clientId).subscribe(
				result => {
					if(result != undefined){
						this.client = result;
					}

					this._reportService.getBalance(this.filter).subscribe(
						result => {
							if(result != undefined){
								this.data = result;
							}
						}
					);

					if(!exportReport)
						return;

					this._reportService.getExportBalanceUrl(this.filter).subscribe(
						result => {
							var blob = new Blob([result], { type: 'application/vnd.ms-excel' });
							saveAs(blob, `${this.client.name} - ${DateHelper.getDateNowString()}.xlsx`)
						}
					)
				}
			);
		}
		catch { }
		finally{
			this.isLoading = false;
		}
    }
    
    showDetails(balance: TripBalanceReport){
        if(balance.trip.showTripContainers)
            balance.trip.showTripContainers = false;
        else
            balance.trip.showTripContainers = true;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/clients/client-collectible/client-collectible.component.ts